import { convertSearchObjectToSearchResult as convertArticleSearchObjectToArticleSearchResult } from '../../../services/search/config/articles/convert-search-object-to-search-result';
import { convertSearchObjectToSearchResult as convertEventeSearchObjectToResourceSearchResult } from '../../../services/search/config/events/convert-search-object-to-search-result';
import { convertSearchObjectToSearchResult as convertProductSearchObjectToProductSearchResult } from '../../../services/search/config/products/convert-search-object-to-search-result';
import { convertSearchObjectToSearchResult as convertResourceSearchObjectToResourceSearchResult } from '../../../services/search/config/resources/convert-search-object-to-search-result';
import { executeSearch as algoliaExecuteSearch } from './providers/algolia/executeSearch';
import { executeSearch as elasticExecuteSearch } from './providers/elastic/executeSearch';
import { executeSearch as pagefindExecuteSearch } from './providers/pagefind/executeSearch';
import { ProviderSearchResults } from './providers/types';
import { SearchResults } from './types';

export const executeSearch = async (
  searchQuery: string,
  locale: string
): Promise<SearchResults> => {
  let results: ProviderSearchResults;

  if (process.env.GATSBY_ELASTICSEARCH_ENGINE) {
    results = await elasticExecuteSearch(searchQuery, locale);
  } else if (process.env.GATSBY_ALGOLIA_INDEX) {
    results = await algoliaExecuteSearch(searchQuery, locale);
  } else {
    results = await pagefindExecuteSearch(searchQuery, locale);
  }

  return {
    articles: results.articles.map(
      convertArticleSearchObjectToArticleSearchResult
    ),
    products: results.products.map(
      convertProductSearchObjectToProductSearchResult
    ),
    resources: results.resources.map(
      convertResourceSearchObjectToResourceSearchResult
    ),
    events: results.events.map(convertEventeSearchObjectToResourceSearchResult),
  };
};
